import { useContext } from 'react';
import { StepperContext } from './Stepper';
export const useStepper = () => {
    const { state, setState } = useContext(StepperContext);
    return [state, setState];
};
